import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
};

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: ""
};

export const emailSendReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_EMAIL_SEND_REQUEST:
      return {...state,
        isFetching: true
      };

    case Constants.GLOBAL_EMAIL_SEND_SUCCESS:
      return {...state,
        isFetching: false
      };

    case Constants.GLOBAL_EMAIL_SEND_FAILURE:
      return {...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_LINK_SEND_REQUEST:
      return {...state,
        isFetching: true
      };

    case Constants.GLOBAL_LINK_SEND_SUCCESS:
      return {...state,
        isFetching: false
      };

    case Constants.GLOBAL_LINK_SEND_FAILURE:
      return {...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };
      
    case Constants.GLOBAL_EMAIL_SEND_CLEAR:
    case Constants.GLOBAL_LINK_SEND_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
